<template>
    <transition name="el-zoom-in-top">
        <div class="content-wrapper">
       <!-- Content Header (Page header) -->
        <section class="content-header">
            <!-- <h1>Toko<small>It's all start from here <i class="ti-heart"></i><i class="ti-export"></i><i class="ti-printer"></i></small></h1> -->
            <ol class="breadcrumb">
                <li><router-link to="/"> <i class="ti-home"></i></router-link></li>
                <li><a href="#">Toko</a></li>
                <li><a href="#/toko_target">Target</a></li>
            </ol>
        </section>
  
            <!-- Main content -->
            <section class="content">
               <!-- Basic Tables-->
                <div class="box">
                    <div class="box-header with-border">
                        <div class="pull-left" style="padding-left: 20px; padding-top: 10px;">
                          <h4><b>TARGET</b></h4>
                        </div>
                        <div class="pull-right" style="padding-right: 20px; padding-top: 10px;">
                          <el-select v-model="toko1" clearable filterable placeholder="Pilih Toko" style="width: 500px"
                              @change="handleSelect1">
                            <el-option
                              v-for="item in region"
                              :key="item.value"
                              :label="item.label"
                              :value="item">
                            </el-option>
                          </el-select>       
                          <el-date-picker v-loading.fullscreen.lock="fullscreenLoading"
                            style="width: 120px"
                            type="month"
                            align="right"
                            v-model="bulan"
                            format="yyyy-MM"
                            value-format="yyyy-MM">
                          </el-date-picker>
                          &nbsp;
                          <el-button icon="el-icon-search" @click="getData()" circle></el-button>
                          <el-button icon="el-icon-plus" type="success" @click="addData()" circle></el-button>
                        </div>
                    </div>           

                    <div class="box-body">
                      
                      <ve-histogram style="width:100%" :data="barData" :settings="barSettings" :resize-delay="100"></ve-histogram>

                    </div>
                </div>

                <el-dialog title="Tambah Data" :visible.sync="dialogFormVisible" v-loading="loadingModalAdd" width="800px" top="2%">
                  <el-form :model="row1" status-icon :rules="rules3" ref="formAdd" :label-width="formLabelWidth" class="demo-ruleForm" @submit.prevent="">
                    <el-form-item label="Toko" prop="kode_toko">
                      <!-- <el-select v-model="row1.kode_toko" clearable filterable placeholder="Pilih Toko"
                        @change="handleSelect">
                        <el-option
                          v-for="item in region"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value">
                        </el-option>
                      </el-select> -->
                      <el-input type="text" v-model="nama_toko" disabled></el-input>
                    </el-form-item>
                    <el-form-item label="Tanggal" prop="tanggal">
                      <el-date-picker @change='handleChangeDate' 
                        v-model="tanggal"
                        type="date"
                        placeholder="Pilih Tanggal">
                      </el-date-picker>
                    </el-form-item>
                    <!-- <el-form-item label="Tanggal" prop="tanggal">
                      <el-input type="text" v-model="row1.tanggal"></el-input>
                    </el-form-item> -->
                    <el-form-item label="Budget" prop="budget">
                      <el-input type="text" v-model="row1.budget"></el-input>
                    </el-form-item>
                  </el-form>
                    <span slot="footer" class="dialog-footer">
                      <el-button @click="dialogFormVisible = false">Batal</el-button>
                      <el-button type="primary" @click="confirmEdit1(0, row1, 'formAdd')">Simpan</el-button>
                    </span>
                </el-dialog>

                <el-dialog title="Edit Data" :visible.sync="dialogFormEdit" v-loading="loadingModalEdit" width="35%" top="3%">
                  <el-form :model="row1" status-icon :rules="rules3" ref="formEdit" :label-width="formLabelWidth" class="demo-ruleForm" @submit.prevent="">
                    <el-form-item label="Toko" prop="kode_toko">
                      <el-autocomplete
                        class="inline-input"
                        v-model="region1"
                        :fetch-suggestions="querySearch"
                        placeholder="Cari Toko"
                        @select="handleSelect"
                      ></el-autocomplete>
                    </el-form-item>
                    <el-form-item label="Bulan" prop="bulan">
                      <el-date-picker @change='handleChangeDate' 
                        v-model="bulan"
                        type="month"
                        placeholder="Pilih Bulan">
                      </el-date-picker>
                    </el-form-item>
                    <el-form-item label="Sales" prop="sales">
                      <el-input type="text" v-model="row1.sales"></el-input>
                    </el-form-item>
                    <el-form-item label="Cost" prop="cost">
                      <el-input type="text" v-model="row1.cost"></el-input>
                    </el-form-item>
                    <el-form-item label="COGS" prop="cogs">
                      <el-input type="text" v-model="row1.cogs"></el-input>
                    </el-form-item>
                    <el-form-item label="Profit" prop="profit">
                      <el-input type="text" v-model="row1.profit"></el-input>
                    </el-form-item>
                    <el-form-item label="Waste" prop="waste">
                      <el-input type="text" v-model="row1.waste" @keyup.enter.native="confirmEdit1(0, row1, 'formEdit')"></el-input>
                    </el-form-item>
                  </el-form>
                    <span slot="footer" class="dialog-footer">
                      <el-button @click="dialogFormEdit = false">Batal</el-button>
                      <el-button type="primary" @click="confirmEdit1(0, row1, 'formEdit')">Simpan</el-button>
                    </span>
                </el-dialog>

                <el-dialog title="Konfirmasi" :visible.sync="dialogFormWilDel" v-loading="loadingModalDel" width="35%">
                  <h4>Apakah Anda yakin akan menghapus data tersebut?</h4>
                  <span slot="footer" class="dialog-footer">
                    <el-button @click="dialogFormWilDel = false">Batal</el-button>
                    <el-button type="primary" @click="confirmDel1()">Ya</el-button>
                  </span>
                </el-dialog>

                <el-dialog title="Informasi" :visible.sync="dialogFormInfo" width="35%">
                  <h5>{{message}}</h5>
                  <span slot="footer" class="dialog-footer">
                    <!-- <el-button @click="dialogFormInfo = false">Batal</el-button> -->
                    <el-button type="primary" @click="dialogFormInfo = false">OK</el-button>
                  </span>
                </el-dialog>
                <!-- End of Basic Tables-->
                
            </section>
            <!-- /.content -->
        </div>
    </transition>
</template>
<script>
    import Vue from 'Vue'
    import VueResource from 'vue-resource'
    import ClipLoader from 'vue-spinner/src/ClipLoader.vue'
    import VueCookie from 'vue-cookie'
    import moment from 'moment'
    import { Bar } from 'vue-chartjs'
    Vue.use(VueCookie)

    import jsonUrl from '../../../assets/url.json'

    Vue.use(VueResource)

    export default {
      extends: Bar,
      name: 'Wilayah',
      components: {
        ClipLoader
      },
      data: function () {
        var validateName = (rule, value, callback) => {
          if (value === '') {
            callback(new Error('Silahkan isi nama wilayah'))
          } else {
            callback()
          }
        }
        var validateArea = (rule, value, callback) => {
          if (value === '') {
            callback(new Error('Silahkan isi nama area'))
          } else {
            callback()
          }
        }
        return {
          barData: {
            columns: ['label', 'budget', 'sales'],
            rows: []
          },
          barSettings: {},
          colorList: [],
          activeName: 'grafik',
          bulan: new Date(),
          tanggal: new Date(),
          region1: '',
          toko1: '',
          row1: {kode: '', nama: '', edit: true},
          tableData: [],
          tableData1: [],
          tableData2: [],
          rules: {
            name: [
              { validator: validateName, trigger: 'blur' }
            ]
          },
          rules2: {
            area: [
              { validator: validateArea, trigger: 'blur' }
            ]
          },
          cari_bulan: '',
          cari_sales: '',
          cari_cost: '',
          cari_cogs: '',
          cari_profit: '',
          cari_waste: '',
          nama: '',
          kode_toko: '',
          nama_toko: '',
          region: [],
          coba: false,
          dialogFormEdit: false,
          dialogFormVisible: false,
          dialogFormWilEdit: false,
          dialogFormWilDel: false,
          dialogFormArea: false,
          loadingModal: false,
          loadingModalAdd: false,
          loadingModalEdit: false,
          loadingModalArea: false,
          loadingModalTambah: false,
          loadingModalDel: false,
          dialogFormInfo: false,
          form: {
            kode: '',
            name: '',
            region: '',
            date1: '',
            date2: '',
            delivery: false,
            type: [],
            resource: '',
            desc: ''
          },
          form1: {
            kode: '',
            name: ''
          },
          form2: {
            kode: '',
            name: '',
            area: ''
          },
          message: '',
          formLabelWidth: 'auto',
          rules3: {
            // kode_toko: [
            //   { required: true, message: 'Silahkan isi toko', trigger: 'change' }
            // ],
            budget: [
              { required: true, message: 'Silahkan isi budget', trigger: 'change' }
            ]
            // sales: [
            //   { required: true, message: 'Silahkan isi sales', trigger: 'change' }
            // ],
            // cost: [
            //   { required: true, message: 'Silahkan isi cost', trigger: 'change' }
            // ],
            // cogs: [
            //   { required: true, message: 'Silahkan isi cogs', trigger: 'change' }
            // ],
            // profit: [
            //   { required: true, message: 'Silahkan isi profit', trigger: 'change' }
            // ],
            // waste: [
            //   { required: true, message: 'Silahkan isi waste', trigger: 'change' }
            // ]
          },
          listQuery: {
            page: 1,
            limit: 20,
            importance: undefined,
            title: undefined,
            type: undefined,
            sort: 'none'
          },
          sortOptions: [{ label: '--', key: 'none' }, { label: 'Nama A-Z', key: '+nama' }, { label: 'Nama Z-A', key: '-nama' }],
          total: null,
          page_size: 31,
          current_page: 1
        }
      },
      methods: {
        toMoney (x) {
          var parts = x.toString().split('.')
          parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',')
          return parts.join('.')
        },
        querySearch: function (queryString, cb) {
          var links = this.region.slice()
          var results = queryString ? links.filter(this.createFilter(queryString)) : links
          cb(results)
        },
        createFilter (queryString) {
          return (link) => {
            return (link.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0)
          }
        },
        handleSelect (item) {
          this.row1.kode_toko = item
        },
        querySearch1: function (queryString, cb) {
          var links = this.region.slice()
          var results = queryString ? links.filter(this.createFilter(queryString)) : links
          cb(results)
        },
        createFilter1 (queryString) {
          return (link) => {
            return (link.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0)
          }
        },
        handleSelect1 (item) {
          var t = JSON.parse(JSON.stringify(item))
          this.kode_toko = t.kode
          this.nama_toko = t.label
          // this.getData()
        },
        resetForm (formName) {
          if (this.$refs[formName] !== undefined) {
            this.$refs[formName].resetFields()
          }
        },
        clearForm: function () {
          this.row1 = {kode: '', tanggal: '', bulan: '', tahun: '', sales: '0', cost: '0', cogs: '0', profit: '0', waste: '0', edit: true, kode_toko: ''}
          this.resetForm('formAdd')
          this.region1 = ''
        },
        cariBulan () {
          var nama = this.cari_bulan + ''
          var newArray = this.tableData2.slice()
          var newArray1 = newArray.filter(function (el) {
            var nama1 = el.bulan + '-' + el.tahun + ''
            return (nama1.toLowerCase().indexOf(nama.toLowerCase()) !== -1)
          })
          this.tableData = newArray1.slice()
          this.handleCurrentChange(this.current_page)
        },
        cariSales () {
          var nama = this.cari_sales + ''
          var newArray = this.tableData2.slice()
          var newArray1 = newArray.filter(function (el) {
            var nama1 = el.sales + ''
            return (nama1.toLowerCase().indexOf(nama.toLowerCase()) !== -1)
          })
          this.tableData = newArray1.slice()
          this.handleCurrentChange(this.current_page)
        },
        cariCost () {
          var nama = this.cari_cost + ''
          var newArray = this.tableData2.slice()
          var newArray1 = newArray.filter(function (el) {
            var nama1 = el.cost + ''
            return (nama1.toLowerCase().indexOf(nama.toLowerCase()) !== -1)
          })
          this.tableData = newArray1.slice()
          this.handleCurrentChange(this.current_page)
        },
        cariCogs () {
          var nama = this.cari_cogs + ''
          var newArray = this.tableData2.slice()
          var newArray1 = newArray.filter(function (el) {
            var nama1 = el.cogs + ''
            return (nama1.toLowerCase().indexOf(nama.toLowerCase()) !== -1)
          })
          this.tableData = newArray1.slice()
          this.handleCurrentChange(this.current_page)
        },
        cariProfit () {
          var nama = this.cari_profit + ''
          var newArray = this.tableData2.slice()
          var newArray1 = newArray.filter(function (el) {
            var nama1 = el.profit + ''
            return (nama1.toLowerCase().indexOf(nama.toLowerCase()) !== -1)
          })
          this.tableData = newArray1.slice()
          this.handleCurrentChange(this.current_page)
        },
        cariWaste () {
          var nama = this.cari_waste + ''
          var newArray = this.tableData2.slice()
          var newArray1 = newArray.filter(function (el) {
            var nama1 = el.waste + ''
            return (nama1.toLowerCase().indexOf(nama.toLowerCase()) !== -1)
          })
          this.tableData = newArray1.slice()
          this.handleCurrentChange(this.current_page)
        },
        handleFilter () {
          var byNama = this.tableData.slice(0)
          if (this.listQuery.sort === '+nama') {
            byNama.sort(function (a, b) {
              var x = a.nama.toLowerCase()
              var y = b.nama.toLowerCase()
              return x < y ? -1 : x > y ? 1 : 0
            })
          } else if (this.listQuery.sort === '-nama') {
            byNama.sort(function (a, b) {
              var x = b.nama.toLowerCase()
              var y = a.nama.toLowerCase()
              return x < y ? -1 : x > y ? 1 : 0
            })
          } else {
            byNama = this.tableData2.slice(0)
          }
          this.tableData = byNama.slice()
          this.handleCurrentChange(this.current_page)
        },
        handleCurrentChange: function (val) {
          this.current_page = val
          this.tableData1 = []
          var a = (this.current_page - 1) * this.page_size
          var b = a + this.page_size
          if (b > this.tableData.length) {
            b = this.tableData.length
          }
          this.tableData1.push({kode: '', edit: true, nama: ''})
          for (var i = a; i < b; i++) {
            this.tableData1.push(this.tableData[i])
          }
        },
        submitForm: function (formName) {
          this.$refs[formName].validate((valid) => {
            if (valid) {
              alert('submit!')
            } else {
              console.log('error submit!!')
              return false
            }
          })
        },
        addData: function () {
          // this.tableData1.unshift({kode: '', nama: '', edit: true})
          this.dialogFormVisible = true
          this.clearForm()
        },
        confirmDet: function (row) {
          this.$router.push('/area/' + row.kode + '/' + row.nama)
        },
        confirmEdit: function (j, row) {
          this.dialogFormEdit = true
          this.region1 = row.toko
          this.row1.kode = row.kode
          this.bulan = row.bulan
          this.row1.kode_toko = row.kode_toko
          this.row1.sales = row.sales
          this.row1.cost = row.cost
          this.row1.cogs = row.cogs
          this.row1.profit = row.profit
          this.row1.waste = row.waste
        },
        cancelEdit: function (j, row) {
          if (row.kode !== '') {
            row.nama = row.nama1
            var item = this.tableData1[j]
            item.edit = false
            this.$set(this.tableData1, j, item)
          } else {
            this.tableData1.splice(j, 1)
          }
        },
        confirmEdit1: function (j, row, formName) {
          this.$refs[formName].validate((valid) => {
            if (valid) {
              if (row.kode !== '') {
                this.loadingModalEdit = true
              } else {
                this.loadingModalAdd = true
              }
              this.dialogFormVisible = false
              this.dialogFormEdit = false

              var req = ''
              var action = '/'
              var tgl = moment(this.tanggal).format('DD')
              var bulan = moment(this.tanggal).format('MM')
              var tahun = moment(this.tanggal).format('YYYY')
              if (row.kode !== '') {
                req = {kode: row.kode, budget: row.budget, kode_toko: this.kode_toko, tanggal: tgl, bulan: bulan, tahun: tahun}
                action += 'updatess'
              } else {
                req = {budget: row.budget, kode_toko: this.kode_toko, tanggal: tgl, bulan: bulan, tahun: tahun}
                action += 'create'
              }
              var req1 = JSON.stringify(req)

              var url = Vue.cookie.get('url') + '/' + jsonUrl.toko_target + action

              Vue.http.post(url, req1, {headers: {'Content-Type': 'application/json', 'Session': localStorage.session}}).then(response => {
                if (response.body.keterangan.toString().indexOf('Session Expired') > -1 || response.body.toString().indexOf('Authorization required') > -1) {
                  this.$router.push('/login')
                } else {
                  this.dialogFormWilEdit = false
                  this.getData()
                  this.loadingModalEdit = false
                  this.loadingModalAdd = false
                  // this.clearForm()
                  this.message = response.body
                  this.dialogFormInfo = true
                }
              }, response => {
                // error callback
                this.dialogFormWilEdit = false
                this.loadingModalEdit = false
                this.loadingModalAdd = false
                // this.clearForm()
              })
            } else {
              return false
            }
          })
        },
        confirmDel: function (row) {
          this.form1.kode = row.kode
          this.nama = row.nama
          this.dialogFormWilDel = true
        },
        confirmDel1: function () {
          this.loadingModalDel = true
          var req = {kode: this.form1.kode}
          var req1 = JSON.stringify(req)

          var url = Vue.cookie.get('url') + '/' + jsonUrl.toko_target + '/delete'

          Vue.http.post(url, req1, {headers: {'Content-Type': 'application/json', 'Session': localStorage.session}}).then(response => {
            // console.log('response ' + JSON.stringify(response.body))
            // if (response.body.status === "SUCCESS") {}
            if (response.body.keterangan.toString().indexOf('Session Expired') > -1 || response.body.toString().indexOf('Authorization required') > -1) {
              this.$router.push('/login')
            } else {
              this.dialogFormWilDel = false
              this.loadingModalDel = false
              this.getData()
              this.message = response.body
              this.dialogFormInfo = true
              this.clearForm()
            }
          }, response => {
            // error callback
            this.dialogFormWilDel = false
            this.loadingModalDel = false
            this.clearForm()
          })
          // this.dialogFormWilDel = false
        },
        getData: function () {
          // this.loadingModal = true
          this.barData.rows = []
          this.colorList = []
          this.tableData = []
          this.tableData1 = []
          var c = this.current_page
          var req = {kode_toko: this.kode_toko, bulan: moment(this.bulan).format('YYYY-MM')}
          var req1 = JSON.stringify(req)

          var url = Vue.cookie.get('url') + '/' + jsonUrl.toko_target + '/read'
          // console.log(localStorage.session)

          Vue.http.post(url, req1, {headers: {'Content-Type': 'application/json', 'Session': localStorage.session}}).then(response => {
            // console.log('response ' + response.body[0].nama)
            if (response.body.keterangan.toString().indexOf('Session Expired') > -1 || response.body.toString().indexOf('Authorization required') > -1) {
              this.$router.push('/login')
            } else {
              this.loadingModal = false
              var arrayResponse = []
              for (var z = 1; z < 32; z++) {
                var t = 't' + z
                var objData = {}
                objData.bulan = moment(this.bulan).format('YYYY-MM')
                objData.tanggal = z
                objData.kode = response.body.data.kode[t]
                objData.budget = response.body.data.budget[t]
                objData.sales = response.body.data.sales[t]
                // objData.kode = (response.body.data.kode[t] == null ? response.body.data.kode[t] : 'fallBackValue')
                arrayResponse.push(objData)

                var objGrafik = {}
                objGrafik.label = z
                objGrafik.budget = response.body.data.budget[t]
                objGrafik.sales = response.body.data.sales[t]

                if (parseInt(response.body.data.sales[t]) >= parseInt(response.body.data.budget[t])) {
                  this.colorList.push('#16A085')
                } else {
                  this.colorList.push('#E74C3C')
                }
                this.barData.rows.push(objGrafik)
                console.log(response.body.data.sales[t])
              }
              console.log(arrayResponse)
              this.tableData = arrayResponse.slice()
              this.total = this.tableData.length
              for (var i = 0; i < this.tableData.length; i++) {
                this.tableData[i].edit = false
                this.tableData[i].no = i + 1
              }
              this.tableData2 = this.tableData.slice()
              var a = 0
              var b = a + this.page_size
              if (b > this.tableData.length) {
                b = this.tableData.length
              }
              for (var j = a; j < b; j++) {
                this.tableData1.push(this.tableData[j])
              }
              this.current_page = c
              this.handleCurrentChange(c)
            }
          }, response => {
            // error callback
            this.loadingModal = false
          })
        },
        getData1: function () {
          // this.loadingModal = true
          this.tableData = []
          this.tableData1 = []
          var req = {kode_toko: this.kode_toko}
          var req1 = JSON.stringify(req)

          var url = Vue.cookie.get('url') + '/' + jsonUrl.toko + '/read_simple'
          // console.log(localStorage.session)

          Vue.http.post(url, req1, {headers: {'Content-Type': 'application/json', 'Session': localStorage.session}}).then(response => {
            // console.log('response ' + response.body[0].nama)
            if (response.body.keterangan.toString().indexOf('Session Expired') > -1 || response.body.toString().indexOf('Authorization required') > -1) {
              this.$router.push('/login')
            } else {
              this.region = response.body.data.slice()
              for (var i = 0; i < this.region.length; i++) {
                this.region[i].value = this.region[i].kode + ''
                this.region[i].label = this.region[i].nama + ''
              }
            }
          }, response => {
            // error callback
          })
        }
      },
      mounted () {
        // if (localStorage.username !== 'root') {
        //   this.$router.replace('/toko')
        // }
        // this.loadingModal = true
        // this.getData()
        this.getData1()

        this.barData = {
          columns: ['label', 'budget', 'sales'],
          rows: [
            { 'label': '1', 'budget': 0, 'sales': 0 },
            { 'label': '2', 'budget': 0, 'sales': 0 },
            { 'label': '3', 'budget': 0, 'sales': 0 },
            { 'label': '4', 'budget': 0, 'sales': 0 },
            { 'label': '5', 'budget': 0, 'sales': 0 },
            { 'label': '6', 'budget': 0, 'sales': 0 },
            { 'label': '7', 'budget': 0, 'sales': 0 },
            { 'label': '8', 'budget': 0, 'sales': 0 },
            { 'label': '9', 'budget': 0, 'sales': 0 },
            { 'label': '10', 'budget': 0, 'sales': 0 }
          ]
        }

        // this.colorList = ['#4f81bd', '#c0504d', '#9bbb59', '#604a7b', '#948a54', '#e46c0b'];
        this.colorList = ['#28B463', '#28B463', '#28B463', '#28B463', '#28B463']

        this.barSettings = {
          metrics: ['budget', 'sales'],
          showLine: ['budget'],
          label: {
            normal: { show: false, position: 'top' }
          },
          itemStyle: {
            normal: {
              color: (params) => {
                // let colorList = ['#e46c0b', '#c0504d', '#e46c0b', '#604a7b', '#948a54', '#e46c0b'];
                return this.colorList[params.dataIndex]
              },
              borderColor: 'rgba(255, 56, 96, 0.5)',
              borderWidth: 0
            }
          }
        }
      },
      watch: {
        'barData': function (to, from) {
          this.renderChart(this.barData, this.barSettings)
          console.log('new data from watcher', to)
        }
      }
    }
</script>

<style>
  .edit-input {
    padding-right: 100px;
  }
  .cancel-btn {
    position: absolute;
    right: 15px;
    top: 10px;
  }
</style>



// WEBPACK FOOTER //
// TokoTarget1.vue?6370bc90